const DEFAULT_WAIT = 1000

export const debounce = <T>(
	callback: (...args: T[]) => void,
	wait = DEFAULT_WAIT
): (() => void) => {
	let debounceTimer: NodeJS.Timeout | null

	return (...args) => {
		if (debounceTimer) {
			clearTimeout(debounceTimer)
		}
		debounceTimer = setTimeout(() => {
			debounceTimer = null
			callback(...args)
		}, wait)
	}
}
